import 'reflect-metadata';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from 'stripe-pwa-elements/loader';
import { isChunkLoadFailure, reportError } from './app/services/error-reporter';

if (environment.production) {
  // window.console.log = () => { }
  // window.console.error = () => { }

  const script = document.createElement('script');
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-MKZK65CW');`;
  document.head.appendChild(script);
}


// Failures Angular's ErrorHandler never sees: a script or stylesheet that did not
// load, and a bundle that broke before the app started. Capture phase, because
// resource errors do not bubble.
window.addEventListener('error', (ev: ErrorEvent | Event) => {
  const target = ev.target as (HTMLElement & { src?: string; href?: string }) | null;
  if (target && target !== (window as any) && (target.src || target.href)) {
    const url = String(target.src || target.href).split('?')[0];
    const file = url.split('/').pop() || '';
    let ours = false;
    try { ours = new URL(url, location.href).origin === location.origin; } catch { /* not a URL */ }
    // Third-party scripts (affiliate widget, Stripe, analytics, ad blockers) are not ours to fix.
    // A lazy chunk (8927.<hash>.js) that fails also throws ChunkLoadError, which is reported once
    // with its own message, so reporting the script tag as well only doubled every incident.
    const lazyChunk = /^\d+\.[0-9a-f]{8,}\.js$/i.test(file);
    if (ours && !lazyChunk && /\.(js|css)$/.test(url)) {
      reportError({ source: 'boot', kind: 'resource_load', message: `Failed to load ${file}` });
    }
    return;
  }
  // Angular's ErrorHandler only sees errors thrown inside its zone. Anything
  // thrown outside it (a third-party script, a plain browser callback) lands here.
  // An error Angular already reported is dropped by the reporter's repeat guard.
  const e = (ev as ErrorEvent).error;
  const message = String((ev as ErrorEvent).message || e?.message || '');
  if (message) {
    reportError({
      kind: isChunkLoadFailure(message) ? 'chunk_load' : 'exception',
      message: message.replace(/^Uncaught (\w*Error: )?/, ''),
      stack: e?.stack
    });
  }
}, true);

window.addEventListener('unhandledrejection', (ev: PromiseRejectionEvent) => {
  const r: any = ev.reason;
  const message = String(r?.message || r || '');
  reportError({
    kind: isChunkLoadFailure(message) ? 'chunk_load' : 'exception',
    message,
    stack: r?.stack
  });
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => defineCustomElements(window))
  .catch(err => {
    console.log(err);
    const message = String(err?.message || err);
    reportError({
      source: 'boot',
      kind: isChunkLoadFailure(message) ? 'chunk_load' : 'bootstrap',
      message,
      stack: err?.stack
    });
  });
